export const CHAT_SIDEBAR_WIDTH = 320;

/** Minimum width for the full-screen chat panel. */
export const FULLSCREEN_CHAT_MIN_WIDTH = 400;

/** Panel width at which the history drawer docks beside the chat content. */
export const FULLSCREEN_PERSISTENT_DRAWER_BREAKPOINT = FULLSCREEN_CHAT_MIN_WIDTH + CHAT_SIDEBAR_WIDTH;

/** Below this panel width the history drawer auto-closes. */
export const FULLSCREEN_SIDEBAR_AUTO_CLOSE_BREAKPOINT = 560;

export type FullscreenSidebarLayoutMode = 'persistent' | 'temporary' | 'hidden';

export const getFullscreenEstimatedPanelWidth = (): number => {
  if (typeof window === 'undefined') {
    return 0;
  }
  const viewportWidth = window.innerWidth > 0 ? window.innerWidth : 1024;
  return Math.min(viewportWidth * 0.85, 1100);
};

export const getEffectiveFullscreenPanelWidth = (measuredWidth: number): number =>
  measuredWidth > 0 ? measuredWidth : getFullscreenEstimatedPanelWidth();

export const getFullscreenSidebarLayoutMode = (panelWidth: number): FullscreenSidebarLayoutMode => {
  if (panelWidth >= FULLSCREEN_PERSISTENT_DRAWER_BREAKPOINT) {
    return 'persistent';
  }
  if (panelWidth >= FULLSCREEN_SIDEBAR_AUTO_CLOSE_BREAKPOINT) {
    return 'temporary';
  }
  return 'hidden';
};
